import React from "react";
import { MapPin, Search, X } from "lucide-react";

const SearchStepNav = ({
  currentStep,
  locationLabel,
  searchKeyword,
  onStepClick,
  onSearchChange,
  onClearSearch,
  inputRef,
}) => {
  const locationValue =
    locationLabel && locationLabel !== "Searching everywhere"
      ? locationLabel
      : "Anywhere";

  const isResultsStep = currentStep === "results";

  return (
    <div className="search-step-nav">
      <div className="search-step-nav__pills">
        <button
          type="button"
          className={`search-step-nav__pill search-step-nav__pill--location ${
            currentStep === "location" ? "search-step-nav__pill--active" : ""
          } ${isResultsStep ? "search-step-nav__pill--complete" : ""}`}
          onClick={() => onStepClick("location")}
        >
          <span className="search-step-nav__pill-icon" aria-hidden="true">
            <MapPin size={18} strokeWidth={2} />
          </span>
          <span className="search-step-nav__pill-text">
            <span className="search-step-nav__pill-label">Location</span>
            <span className="search-step-nav__pill-value">{locationValue}</span>
          </span>
        </button>

        <span className="search-step-nav__connector" aria-hidden="true" />

        {isResultsStep ? (
          <div className="search-step-nav__pill search-step-nav__pill--active search-step-nav__pill--expanded search-step-nav__pill--search-field">
            <span className="search-step-nav__pill-icon" aria-hidden="true">
              <Search size={18} strokeWidth={2} />
            </span>
            <span className="search-step-nav__pill-text search-step-nav__pill-text--grow">
              <span className="search-step-nav__pill-label">Search</span>
              <div className="search-step-nav__search-input-row">
                <input
                  ref={inputRef}
                  type="text"
                  className="search-step-nav__search-input"
                  placeholder="Search..."
                  value={searchKeyword || ""}
                  onChange={onSearchChange}
                  aria-label="Search keywords"
                />
                {searchKeyword ? (
                  <button
                    type="button"
                    className="search-step-nav__search-clear"
                    onClick={onClearSearch}
                    aria-label="Clear search"
                  >
                    <X size={16} strokeWidth={2.5} />
                  </button>
                ) : null}
              </div>
            </span>
          </div>
        ) : (
          <button
            type="button"
            className="search-step-nav__pill search-step-nav__pill--search"
            onClick={() => onStepClick("results")}
            disabled
          >
            <span className="search-step-nav__pill-icon" aria-hidden="true">
              <Search size={18} strokeWidth={2} />
            </span>
            <span className="search-step-nav__pill-text">
              <span className="search-step-nav__pill-label">Search</span>
              <span className="search-step-nav__pill-value">Keywords</span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchStepNav;
